import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateApplicationDetailsBpamsConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LABEL = "Description";
    static IS_MINOR_BUILDING_WORK_LABEL = "Is there minor building work?";
    static OTHER_BUILDING_USE_LABEL = "Other building use?";
    static IS_ALTERATIONS_LABEL = "Is the application for any alterations or additions?";
    static IS_RESIDENTIAL_APPLICATION_LABEL = "Is this a residential application?";
    static SECTOR_LABEL = "Sector";
    static IS_RDP_LABEL = "Is it an RDP house?";
    static BUILDING_USE_LABEL = "Building use";
    static APPLICATION_TYPE_LABEL = "Type";
    static APPLICATION_ESTIMATED_BY_LABEL = "Estimated by";
    static APPLICATION_ESTIMATED_COST_LABEL = "Estimated project cost (R)";
    static PREVIOUS_REFERENCE_NUMBER_LABEL = "Previous reference number";
    static IS_RESUBMISSION_LABEL = "Is this application a resubmission?";
    static IS_EXTENSION_LABEL = "Do you want to extend an existing application?";
    static DETAILS_FORM_GROUP_NAME = "detailsForm";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static IS_MINOR_BUILDING_WORK_FORM_CONTROL_NAME = "isMinorBuildingWork";
    static IS_RESIDENTIAL_APPLICATION_CONTROL_NAME = "isResidential";
    static IS_ALTERATIONS_CONTROL_NAME = "isAlterations";
    static IS_BUILDING_USE_OTHER_CONTROL_NAME = "isBuildingUseOther";
    static BUILDING_TYPE_CONTROL_NAME = "buildingType";
    static SECTOR_FORM_CONTROL_NAME = "sector";
    static IS_RDP_FORM_CONTROL_NAME = "isRdp";
    static BUILDING_USE_FORM_CONTROL_NAME = "buildingUse";
    static APPLICATION_TYPE_FORM_CONTROL_NAME = "applicationType";
    static APPLICATION_ESTIMATED_BY_FORM_CONTROL_NAME = "applicationEstimatedBy";
    static APPLICATION_ESTIMATED_COST_FORM_CONTROL_NAME = "applicationEstimatedCost";
    static PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME = "previousReferenceNumber";
    static IS_RESUBMISSION_FORM_CONTROL_NAME = "isResubmission";
    static IS_EXTENSION_FORM_CONTROL_NAME = "isExtension";
    static NON_RESIDENTIAL_BUILDING_USE_OPTION_LOOKUP_NAME = "nonResidentialBuildingUse";
    static RESIDENTIAL_BUILDING_USE_OPTION_LOOKUP_NAME = "residentialBuildingUse";
    static TYPE_OPTION_LOOKUP_NAME = "typeOptions";
    static ESTIMATED_BY_OPTION_LOOKUP_NAME = "estimatedByOptions";
    static BUILDING_USE_OPTION_LOOKUP_NAME = "buildingUseOptions";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        isMinorBuildingWork: {
            required: `Is there minor building work ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        isResidentialApplication: {
            required: `Is residential application ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        isAlterations: {
            required: `Is alterations ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        otherBuildingUse: {
            required: `Other building use ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        sector: {
            required: `Sector ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        isRdp: {
            required: `Is it an RDP house ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        buildingUse: {
            required: `Building use ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationType: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationEstimatedBy: {
            required: `Estimated by ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        applicationEstimatedCost: {
            required: `Estimated cost ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
